var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "validation-popup",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__(
          "documents.overview.menu.ValidationPopup.finalising_your_document"
        )
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("update:show", false)
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "dialog__default" }, [
          _vm.edit === false
            ? _c("div", [
                _vm.doctype == "invoice"
                  ? _c("p", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Cette action va transformer votre brouillon en facture"
                            )
                          ) +
                          "\n                    "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre facture prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires."
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.doctype == "creditnote"
                  ? _c("p", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Cette action va transformer votre brouillon en avoir"
                            )
                          ) +
                          "\n                    "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Cette action est définitive, vous ne pourrez plus choisir le statut brouillon par la suite. Votre avoir prendra un numéro officiel et sera comptabilisée dans votre chiffre d’affaires."
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3 acenter" }, [
                  _vm.doctype == "invoice"
                    ? _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$l10n.__("Votre facture sera datée du")
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.doctype == "creditnote"
                    ? _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Votre avoir sera daté du")) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("strong", { staticClass: "fs-4 mt-1 block" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.validateDate) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "link fs-2 mt-2 block",
                      on: {
                        click: function($event) {
                          _vm.edit = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__("Modifier la date de facturation")
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ])
              ])
            : _c("div", [
                _c("p", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "La date de facturation devrait suivre l’ordre chronologique des numéros de facturation."
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4 acenter" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__("Selectionnez une date de facturation")
                        ) +
                        "\n                    "
                    ),
                    _c("el-date-picker", {
                      attrs: {
                        clearable: false,
                        format: _vm.datePickerFormat,
                        pickerOptions: _vm.pickerOptions,
                        type: "date"
                      },
                      model: {
                        value: _vm.date,
                        callback: function($$v) {
                          _vm.date = $$v
                        },
                        expression: "date"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link fs-2 mt-2 block",
                        on: {
                          click: function($event) {
                            _vm.date = _vm.initDate
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Réinitialiser la date")) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("update:show", false)
                }
              }
            }),
            _vm._v(" "),
            _vm.edit
              ? _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.save"),
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      _vm.edit = false
                    }
                  }
                })
              : _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.action,
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: { click: _vm.finish }
                })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }